/// <reference path="../../../../typings/index.d.ts" />
(function($) {
    //Добавление token ко всем ajax запросам
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
    $('#log_in_form').submit(function(event){
        event.preventDefault();
        $('.er').html('');
        var form_data = $(this).serializeArray();
        if (validation()){
            $.ajax({
                type: 'POST',
                url: 'check/login',
                data: form_data,
                dataType: 'json',
                beforeSend: function () {
                    $('.er_serv_span').css({
                        'display': 'none'
                    });
                    $('.loader').show();
                },
                success: function(data) {
                    if (data.code == 202) {
                        window.location.replace("cabinet");
                    }
                    else {
                        $('.er_serv_span').css({
                            'display': 'inline-block',
                            'color': '#ff0000',
                            'font-weight': 'bold'
                        }).html(data.error);
                    }
                },
                complete: function () {
                    $('.loader').hide();
                }
            });
        }
    });
    //Валидация на стороне клиента
    function validation() {
        $('.er').html('');

        $('#login_reg').change(function(event){
            sbros(val_login(),'.er1');
        });
        $('#password_reg').change(function(event){
            sbros(val_password(),'.er2');
        });

        //Проверка логина
        function val_login() {
            var valid_name = false;
            var pattern1 = /^.{3,}$/i;

            if ($('#login_reg').val() != '') {
                if (pattern1.test($('#login_reg').val())) {
                    valid_name = true;
                }
                else {
                    $('.er1').html('Логин должен состоять минимум из 3 символов');
                }
            }
            else {
                $('.er1').html('Введите логин');
            }

            return valid_name;
        }

        //Проверка пароля
        function val_password(){
            var valid_password = false;
            if ($('#password_reg').val() != '') {
                valid_password = true;
            }
            else {
                $('.er2').html('Введите пароль');
            }

            return valid_password;
        }

        //Сброс поля с ошибкой
        function sbros(func,pole) {
            if (func) {
                $(pole).html('');
            }
        }

        var e = val_login();
        var p = val_password();
        return (e && p);
    }   
})(jQuery);